import { render, staticRenderFns } from "./changePsd.vue?vue&type=template&id=740e6430&scoped=true"
import script from "./changePsd.vue?vue&type=script&lang=js"
export * from "./changePsd.vue?vue&type=script&lang=js"
import style0 from "./changePsd.vue?vue&type=style&index=0&id=740e6430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e6430",
  null
  
)

export default component.exports